import {
  createModalDataToken,
  createModalOpener
} from 'src/app/helpers/create-modal-opener';
import { ProcessElementDto } from 'src/app/models/process/process-element-dto';
import { RulePropertyEditEvent } from '../../model/rule-property-edit-event';
import { NotificationsSetupProcessIdsModalComponent } from './notifications-setup-process-ids-modal.component';

interface NotificationsSetupProcessIdsModalInput {
  readonly notificationRuleId: string;
  readonly processNodes: ProcessElementDto[];
}

export interface NotificationsSetupProcessIdsModalOutput {
  readonly saveAction: RulePropertyEditEvent<ProcessElementDto[]>;
  readonly cancelAction: void;
}

export const NOTIFICATIONS_SETUP_PROCESS_IDS_MODAL_DATA =
  createModalDataToken<NotificationsSetupProcessIdsModalInput>(
    'NotificationsSetupProcessIdsModalData'
  );

export const notificationsSetupProcessIdsModalOpener = createModalOpener<
  NotificationsSetupProcessIdsModalComponent,
  NotificationsSetupProcessIdsModalInput,
  NotificationsSetupProcessIdsModalOutput
>(
  NotificationsSetupProcessIdsModalComponent,
  NOTIFICATIONS_SETUP_PROCESS_IDS_MODAL_DATA,
  { backdrop: 'static' }
);
